import {
  ControllingFilters,
  ControllingSortField,
  ScheduleStatus,
  DeviationStatus,
  ControllingReasonFilterValue,
} from '@myapp/contract'
import {
  toOptionalNumber,
  toOptionalString,
  toOptionalFloat,
} from '../../../../shared/lib/optionalParsers'

export type { ControllingSortField, ScheduleStatus, DeviationStatus, ControllingReasonFilterValue }

export type ControllingSortDirection = 'ASC' | 'DESC'

export interface ControllingFiltersForm {
  dateFrom: string
  dateTo: string
  workOrderId: string
  technicianId: string
  tenant: string
  ve: string
  building: string
  tradeId: string
  technicianTradeId: string
  scheduleStatus: ScheduleStatus[]
  deviationStatus: DeviationStatus[]
  reasons: ControllingReasonFilterValue[]
  actualTravelHoursMin: string
  actualTravelHoursMax: string
  actualWorkHoursMin: string
  actualWorkHoursMax: string
  actualTotalHoursMin: string
  actualTotalHoursMax: string
  deviationMin: string
  deviationMax: string
  sortField: ControllingSortField
  sortDirection: ControllingSortDirection
}

export const INITIAL_CONTROLLING_FILTERS: ControllingFiltersForm = {
  dateFrom: '',
  dateTo: '',
  workOrderId: '',
  technicianId: '',
  tenant: '',
  ve: '',
  building: '',
  tradeId: '',
  technicianTradeId: '',
  scheduleStatus: [],
  deviationStatus: [],
  reasons: [],
  actualTravelHoursMin: '',
  actualTravelHoursMax: '',
  actualWorkHoursMin: '',
  actualWorkHoursMax: '',
  actualTotalHoursMin: '',
  actualTotalHoursMax: '',
  deviationMin: '',
  deviationMax: '',
  sortField: 'repairDate',
  sortDirection: 'DESC',
}

export const mapFiltersFormToApi = (
  f: ControllingFiltersForm,
  limit: number,
): ControllingFilters => ({
  limit,
  dateFrom: toOptionalString(f.dateFrom),
  dateTo: toOptionalString(f.dateTo),
  workOrderId: toOptionalString(f.workOrderId),
  technicianId: toOptionalNumber(f.technicianId),
  tenant: toOptionalString(f.tenant),
  ve: toOptionalString(f.ve),
  building: toOptionalString(f.building),
  tradeId: toOptionalNumber(f.tradeId),
  technicianTradeId: toOptionalNumber(f.technicianTradeId),
  scheduleStatus: f.scheduleStatus.length > 0 ? f.scheduleStatus : undefined,
  deviationStatus: f.deviationStatus.length > 0 ? f.deviationStatus : undefined,
  reasons: f.reasons.length > 0 ? f.reasons : undefined,
  actualTravelHoursMin: toOptionalFloat(f.actualTravelHoursMin),
  actualTravelHoursMax: toOptionalFloat(f.actualTravelHoursMax),
  actualWorkHoursMin: toOptionalFloat(f.actualWorkHoursMin),
  actualWorkHoursMax: toOptionalFloat(f.actualWorkHoursMax),
  actualTotalHoursMin: toOptionalFloat(f.actualTotalHoursMin),
  actualTotalHoursMax: toOptionalFloat(f.actualTotalHoursMax),
  deviationMin: toOptionalNumber(f.deviationMin),
  deviationMax: toOptionalNumber(f.deviationMax),
  sortField: f.sortField,
  sortDirection: f.sortDirection,
})
